/**
 * @file
 * Commerce: Product.
 */
(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.medihumCommerceProduct = {
    attach: function (context, settings) {
      var self = this;

      $('article.product').once('commerce-product-process').each(function () {
        var $wrapper = $(this);
        var $tabs = $wrapper.find('.meta__wrapper .tabs');
        var $tabs_content = $wrapper.find('.meta__wrapper .tabs-content');
        var $gallery = $wrapper.find('.content__wrapper .gallery');

        var flickity_options = {
          resize: true,
          contain: true,
          groupCells: true,
          prevNextButtons: true,
          pageDots: false,
          freeScroll: true,
          cellAlign: 'left',
          imagesLoaded: true
        };

        // Tabs content slider (accessories)
        if ($tabs_content.find('.mandatory-accessories').length) {
          $tabs_content.find('.mandatory-accessories .view-product-accessories .view-content > .content').each(function (i, item) {
            self.buildSlider($(item), flickity_options);
          });
        }

        if ($tabs_content.find('.recommended-accessories').length) {
          $tabs_content.find('.recommended-accessories .view-product-accessories .view-content > .content').each(function (i, item) {
            self.buildSlider($(item), flickity_options);
          });
        }

        // Alternative products slider
        flickity_options.freeScroll = false;
        if ($wrapper.find('.footer__wrapper .similar-products-wrapper').length) {
          self.buildSlider($wrapper.find('.footer__wrapper .similar-products-wrapper .view-product-accessories .view-content'), flickity_options);
        }

        // Gallery slider
        self.buildGallerySlider($gallery.find('.field--name-field-gallery .slider'), $gallery.find('.field--name-field-gallery .nav'), flickity_options);

        // Re-attach behavior after change variant over ajax
        $(document).ajaxComplete(function (event, xhr, settings) {
          self.buildGallerySlider($gallery.find('.field--name-field-gallery .slider'), $gallery.find('.field--name-field-gallery .nav'), flickity_options);
          self.buildQuantityButtons($wrapper);
          $(window).trigger('resize');
        });

        // Scroll to links
        self.scrollTo($wrapper, $tabs, 'description', 'a.read-more');
        self.scrollTo($wrapper, $tabs, 'mandatory-accessories', '.message a');

        // Tab open behavior
        $tabs.on('click', '.links > li > a', function (e) {
          e.preventDefault();

          $tabs_content.find('> div').removeClass('active');
          $tabs_content.find('> .' + $(this).data('id')).addClass('active');
          $tabs.find('.links > li > a').removeClass('active');
          $(this).addClass('active');

          $tabs_content.find('.flickity-enabled').each(function (i, item) {
            $(item).flickity('resize');
          });
        });

        setTimeout(function () {
          // Add to cart quantity increase/decrease
          self.buildQuantityButtons($wrapper);
        }, 100);

        setTimeout(function () {
          // Resize flickity slider
          $(window).trigger('resize');
        }, 250);
      });
    },
    scrollTo: function (wrapper, tabs, id, selector) {
      wrapper.on('click', selector, function (e) {
        e.preventDefault();

        tabs.find('.links > li > a[data-id="' + id + '"]').click();

        $('html, body').animate({
          scrollTop: tabs.offset().top
        }, 600);
      });
    },
    buildQuantityButtons: function (wrapper) {
      wrapper.find('form.commerce-order-item-add-to-cart-form .field--name-quantity').once('quantity-field-processed').each(function () {
        var $field = $(this);

        if (!wrapper.find('form.ajax-add-to-cart-form').length) {
          $field.on('click', 'span.step-down', function (e) {
            $(this).parent().parent().find('input[name="quantity[0][value]"]')[0].stepDown();
          });

          $field.on('click', 'span.step-up', function (e) {
            $(this).parent().parent().find('input[name="quantity[0][value]"]')[0].stepUp();
          });
        }
      });
    },
    buildSlider: function (wrapper, options) {
      wrapper.flickity(options);
    },
    buildGallerySlider: function (carousel, carousel_nav, options) {
      var flickity;
      var nav_height = carousel_nav.height();
      var nav_item_height = carousel_nav.find('.field__item').height();

      options.lazyLoad = true;

      carousel_nav.on('click', '.field__item', function (event) {
        carousel.flickity('select', $(event.currentTarget).index());
      });

      carousel.lightGallery({
        thumbnail: false
      });

      carousel.on('select.flickity', function () {
        carousel_nav.find('.is-nav-selected').removeClass('is-nav-selected');

        var index = flickity !== undefined ? flickity.selectedIndex : 0;
        var selected = carousel_nav.find('.field__item').eq(index).addClass('is-nav-selected');
        var offset = selected.position().top + carousel_nav.scrollTop() - (nav_height + nav_item_height) / 2;

        if (carousel_nav.scrollTop() != offset) {
          carousel_nav.stop().animate({
            scrollTop: offset
          }, 300);
        }
      });

      $(window).bind('resize', function () {
        flickity = carousel.data('flickity');

        if ($(window).width() < 768) {
          options.prevNextButtons = true;
          options.pageDots = true;
        }
        else {
          options.prevNextButtons = false;
          options.pageDots = false;
        }

        if (flickity !== undefined) {
          if (options.pageDots != flickity.options.pageDots) {
            carousel.flickity('destroy');
          }
        }

        carousel.flickity(options);
      });
    },
  };

})(jQuery, Drupal);
